var React = require('react');

class OneHotspurButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const Tag = (this.props.tag && this.props.tag !== '') ? this.props.tag : 'a';
        const href = (Tag === 'a' && this.props.href && this.props.href !== '') ? this.props.href : null;
        const target = (Tag === 'a' && this.props.target && this.props.target !== '') ? this.props.target : null;
        const rel = (target && target === '_blank') ? 'noopener external' : null;
        let buttonClass = 'c-button c-button--one-hotspur';
        if (this.props.size && this.props.size === 'small') buttonClass += ' c-button--small';
        if (this.props.size && this.props.size === 'large') buttonClass += ' c-button--large';
        if (this.props.reverse && this.props.reverse === 'true') buttonClass += ' c-button--reverse';
        if (this.props.alt && this.props.alt === 'true') buttonClass += ' c-button--alt';
        if (this.props.rounded && this.props.rounded === 'true') buttonClass += ' c-button--rounded';
        return (
            <Tag className={buttonClass} href={href} target={target} rel={rel}>{this.props.text}</Tag>
        );
    }
}

module.exports = OneHotspurButton;



// WEBPACK FOOTER //
// ./src/components/OneHotspurButton/OneHotspurButton.js